import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, ref, watch, computed } from 'vue'
import { api } from "@/main";
import store from "@/store";
import { Subscription, UITimerHolder } from "@/api";
import Card from "@/components/Card.vue";
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimerDashboard',
  props: ['household', 'timerHolderId'],
  setup(__props) {

const props = __props



const timerHolder = ref<UITimerHolder | null>(null);
let timerHolderSubscription: Subscription | null = null;

watch(() => props.timerHolderId, (newId) => {
  if (timerHolderSubscription)
    api.unsubscribe(timerHolderSubscription);

  timerHolder.value = null;
  timerHolderSubscription = api.timer.subscribeToTimerHolder(newId, (newValue) => {
    timerHolder.value = newValue;
  });
}, { immediate: true });

const now = ref(Date.now());
let intervalId: number | null = null;
onMounted(() => {
  intervalId = window.setInterval(() => {
    now.value = Date.now();
  }, 33);
});

// Clean up the interval when the component is unmounted
onUnmounted(() => {
  if (intervalId !== null) {
    clearInterval(intervalId);
  }
  if (timerHolderSubscription) {
    api.unsubscribe(timerHolderSubscription);
  }
});

const formatCountdown = (timestamp: string) => {
  const targetTime = moment(timestamp);
  const currentTime = moment(now.value);

  if (currentTime.isAfter(targetTime)) {
    return "Done!";
  }

  // Get the difference in milliseconds
  const diff = targetTime.diff(currentTime);

  // Format as days, hours, minutes, seconds, milliseconds
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);
  const milliseconds = diff % 1000;

  // Create a formatted string
  let result = '';
  if (days > 0) result += `${days}d `;
  if (hours > 0 || days > 0) result += `${hours}h `;
  if (minutes > 0 || hours > 0 || days > 0) result += `${minutes}m `;
  result += `${seconds}.${milliseconds.toString().padStart(3, '0')}s`;

  return result;
};

const newTimerString = ref('');
const isReconnecting = computed(() => store.state.connectionState === 'reconnecting');


return { __sfc: true,props, timerHolder, timerHolderSubscription, now, intervalId, formatCountdown, newTimerString, isReconnecting, api, Card }
}

})